<ng-container *ngIf="works && works.length==0">
	<div class="no-result-margin">{{ "WORK.NO_WORK" | translate}}</div>
</ng-container>

<ng-container *ngIf="works && works.length>0">
	<!--Выводим работы для десктопов-->
	<div class="grid-tiles visible-desktop o-hidden">
		<div class="inner clearfix " *ngFor="let row of desktopWorks">
			<ng-container *ngIf="row.type==0">
				<div class="one-third-cell cell plate--two-height">
					<tile-item *ngIf="row.data[0]" [srcUrl]="srcUrl" [dataItem]="row.data[0]" [imageType]="'block2x2'" [classList]="'plate--two-height'"></tile-item>
				</div>
				<div class="
					one-third-cell cell" *ngIf="row.data.length>1">
					<tile-item *ngIf="row.data[1]" [srcUrl]="srcUrl" [dataItem]="row.data[1]" [classList]="'plate--horizontal mb'"
					 [imageType]="'block2x1'"></tile-item>
					<tile-item *ngIf="row.data[2]" [srcUrl]="srcUrl" [dataItem]="row.data[2]" [classList]="'hw'" [imageType]="'block1x1'"></tile-item>
					<tile-item *ngIf="row.data[3]" [srcUrl]="srcUrl" [dataItem]="row.data[3]" [classList]="'hw ml'" [imageType]="'block1x1'"></tile-item>
				</div>
				<div class="one-sixth-cell v-cell cell " *ngIf="row.data.length>4">
					<tile-item *ngIf="row.data[4]" [srcUrl]="srcUrl" [dataItem]="row.data[4]" [classList]="'plate--vertical'"
					 [imageType]="'block1x2'"></tile-item>
				</div>
				<div class="one-sixth-cell cell" *ngIf="row.data.length>5">
					<tile-item *ngIf="row.data[5]" [srcUrl]="srcUrl" [dataItem]="row.data[5]" [classList]="'mb'" [imageType]="'block1x1'"></tile-item>
					<tile-item *ngIf="row.data[6]" [srcUrl]="srcUrl" [dataItem]="row.data[6]" [imageType]="'block1x1'"></tile-item>
				</div>
			</ng-container>

			<ng-container *ngIf="row.type==1">
				<div class="one-third-cell cell">
					<tile-item *ngIf="row.data[0]" [srcUrl]="srcUrl" [dataItem]="row.data[0]" [classList]="'plate--horizontal mb'"
					 [imageType]="'block2x1'"></tile-item>
					<tile-item *ngIf="row.data[1]" [srcUrl]="srcUrl" [dataItem]="row.data[1]" [classList]="'hw'" [imageType]="'block1x1'"></tile-item>
					<tile-item *ngIf="row.data[2]" [srcUrl]="srcUrl" [dataItem]="row.data[2]" [classList]="'hw ml'" [imageType]="'block1x1'"></tile-item>
				</div>
				<div class="one-sixth-cell v-cell cell" *ngIf="row.data[3]">
					<tile-item *ngIf="row.data[3]" [srcUrl]="srcUrl" [dataItem]="row.data[3]" [classList]="'plate--vertical'"
					 [imageType]="'block1x2'"></tile-item>
				</div>
				<div class="one-third-cell cell  plate--two-height" *ngIf="row.data[4]">
					<tile-item *ngIf="row.data[4]" [srcUrl]="srcUrl" [dataItem]="row.data[4]" [imageType]="'block2x2'" [classList]="'plate--two-height'"></tile-item>
				</div>
				<div class="one-sixth-cell v-cell cell clearfix" *ngIf="row.data[5]">
					<tile-item *ngIf="row.data[5]" [srcUrl]="srcUrl" [dataItem]="row.data[5]" [classList]="'plate--vertical'"
					 [imageType]="'block1x2'"></tile-item>
				</div>
			</ng-container>
			<ng-container *ngIf="row.type==2">
				<div class="one-sixth-cell v-cell cell">
					<tile-item *ngIf="row.data[0]" [srcUrl]="srcUrl" [dataItem]="row.data[0]" [classList]="'plate--vertical'"
					 [imageType]="'block1x2'"></tile-item>
				</div>
				<div class="one-third-cell cell" *ngIf="row.data.length>1">
					<tile-item *ngIf="row.data[1]" [srcUrl]="srcUrl" [dataItem]="row.data[1]" [classList]="'hw mb'" [imageType]="'block1x1'"></tile-item>
					<tile-item *ngIf="row.data[2]" [srcUrl]="srcUrl" [dataItem]="row.data[2]" [classList]="'hw mb ml'" [imageType]="'block1x1'"></tile-item>
					<tile-item *ngIf="row.data[3]" [srcUrl]="srcUrl" [dataItem]="row.data[3]" [classList]="'plate--horizontal'"
					 [imageType]="'block2x1'"></tile-item>
				</div>
				<div class="one-third-cell cell plate--two-height" *ngIf="row.data[4]">
					<tile-item *ngIf="row.data[4]" [srcUrl]="srcUrl" [dataItem]="row.data[4]" [imageType]="'block2x2'" [classList]="'plate--two-height'"></tile-item>
				</div>
				<div class="one-sixth-cell v-cell cell clearfix" *ngIf="row.data[5]">
					<tile-item *ngIf="row.data[5]" [srcUrl]="srcUrl" [dataItem]="row.data[5]" [classList]="'plate--vertical'"
					 [imageType]="'block1x2'"></tile-item>
				</div>
			</ng-container>
		</div>
	</div>

	<!--Выводим работы для планшетов-->
	<div class="grid-tiles visible-tablet o-hidden">
		<div class="inner clearfix" *ngFor="let row of tabletWorks">
			<ng-container *ngIf="row.type==0">
				<div class="one-third-cell cell plate--two-height" *ngIf="row.data[0]">
					<tile-item *ngIf="row.data[0]" [srcUrl]="srcUrl" [dataItem]="row.data[0]" [imageType]="'block2x2'" [classList]="'plate--two-height'"></tile-item>
				</div>
				<div class="one-third-cell cell clearfix" *ngIf="row.data.length>1">
					<tile-item *ngIf="row.data[1]" [srcUrl]="srcUrl" [dataItem]="row.data[1]" [classList]="'mb plate--horizontal'"
					 [imageType]="'block2x1'"></tile-item>
					<tile-item *ngIf="row.data[2]" [srcUrl]="srcUrl" [dataItem]="row.data[2]" [classList]="'hw'" [imageType]="'block1x1'"></tile-item>
					<tile-item *ngIf="row.data[3]" [srcUrl]="srcUrl" [dataItem]="row.data[3]" [classList]="'hw ml'" [imageType]="'block1x1'"></tile-item>
				</div>
				<div class="one-sixth-cell v-cell cell" *ngIf="row.data.length>4">
					<tile-item *ngIf="row.data[4]" [srcUrl]="srcUrl" [dataItem]="row.data[4]" [classList]="'plate--vertical'"
					 [imageType]="'block1x2'"></tile-item>
				</div>
			</ng-container>
			<ng-container *ngIf="row.type==1">
				<div class="one-third-cell cell">
					<tile-item *ngIf="row.data[0]" [srcUrl]="srcUrl" [dataItem]="row.data[0]" [classList]="'mb plate--horizontal'"
					 [imageType]="'block2x1'"></tile-item>
					<tile-item *ngIf="row.data[1]" [srcUrl]="srcUrl" [dataItem]="row.data[1]" [classList]="'hw'" [imageType]="'block1x1'"></tile-item>
					<tile-item *ngIf="row.data[2]" [srcUrl]="srcUrl" [dataItem]="row.data[2]" [classList]="'hw ml'" [imageType]="'block1x1'"></tile-item>
				</div>
				<div class="one-sixth-cell v-cell cell" *ngIf="row.data[3]">
					<tile-item [srcUrl]="srcUrl" [dataItem]="row.data[3]" [classList]="'plate--vertical'" [imageType]="'block1x2'"></tile-item>
				</div>
				<div class="one-third-cell cell plate--two-height" *ngIf="row.data[4]">
					<tile-item [srcUrl]="srcUrl" [dataItem]="row.data[4]" [imageType]="'block2x2'" [classList]="'plate--two-height'"></tile-item>
				</div>
			</ng-container>
			<ng-container *ngIf="row.type==2">
				<div class="one-sixth-cell v-cell cell">
					<tile-item *ngIf="row.data[0]" [srcUrl]="srcUrl" [dataItem]="row.data[0]" [classList]="'plate--vertical'"
					 [imageType]="'block1x2'"></tile-item>
				</div>
				<div class="one-third-cell cell" *ngIf="row.data.length>1">
					<tile-item *ngIf="row.data[1]" [srcUrl]="srcUrl" [dataItem]="row.data[1]" [classList]="'hw mb'" [imageType]="'block1x1'"></tile-item>
					<tile-item *ngIf="row.data[2]" [srcUrl]="srcUrl" [dataItem]="row.data[2]" [classList]="'hw mb ml'" [imageType]="'block1x1'"></tile-item>
					<tile-item *ngIf="row.data[3]" [srcUrl]="srcUrl" [dataItem]="row.data[3]" [classList]="'plate--horizontal'"
					 [imageType]="'block2x1'"></tile-item>
				</div>
				<div class="one-third-cell cell plate--two-height" *ngIf="row.data[4]">
					<tile-item [srcUrl]="srcUrl" [dataItem]="row.data[4]" [imageType]="'block2x2'" [classList]="'plate--two-height'"></tile-item>
				</div>
			</ng-container>
		</div>
	</div>

	<!--Выводим работы для мобильных-->
	<div class="grid-tiles visible-mobile o-hidden">
		<div class="inner clearfix " *ngFor="let row of mobileWorks">
			<ng-container *ngIf="row.type==0">
				<div class="one-third-cell cell plate--two-height">
					<tile-item [srcUrl]="srcUrl" [dataItem]="row.data[0]" [imageType]="'block2x2'" [classList]="'plate--two-height'"></tile-item>
				</div>
				<div class="clearfix"></div>
				<div class="one-third-cell cell plate--two-height" *ngIf="row.data[1]">
					<tile-item [srcUrl]="srcUrl" [dataItem]="row.data[1]" [imageType]="'block2x2'" [classList]="'plate--two-height'"></tile-item>
				</div>
				<div class="clearfix"></div>
				<div class="one-third-cell cell" *ngIf="row.data.length>2">
					<tile-item *ngIf="row.data[2]" [srcUrl]="srcUrl" [dataItem]="row.data[2]" [classList]="'hw'" [imageType]="'block1x1'"></tile-item>
					<tile-item *ngIf="row.data[3]" [srcUrl]="srcUrl" [dataItem]="row.data[3]" [classList]="'hw ml'" [imageType]="'block1x1'"></tile-item>
				</div>
				<div class="clearfix"></div>

				<div class="one-third-cell cell" *ngIf="row.data[4]">
					<tile-item [srcUrl]="srcUrl" [dataItem]="row.data[4]" [classList]="'plate--horizontal'" [imageType]="'block2x1'"></tile-item>
				</div>
				<div class="clearfix"></div>
				<div class="one-third-cell cell" *ngIf="row.data[5]">
					<tile-item [srcUrl]="srcUrl" [dataItem]="row.data[5]" [classList]="'plate--horizontal'" [imageType]="'block2x1'"></tile-item>
				</div>
				<div class="clearfix"></div>
				<div class="one-third-cell cell" *ngIf="row.data[6]">
					<tile-item [srcUrl]="srcUrl" [dataItem]="row.data[6]" [classList]="'plate--horizontal'" [imageType]="'block2x1'"></tile-item>
				</div>
			</ng-container>
			<ng-container *ngIf="row.type==1">
				<div class="one-third-cell cell clearfix plate--two-height">
					<tile-item [srcUrl]="srcUrl" [dataItem]="row.data[0]" [imageType]="'block2x2'" [classList]="'plate--two-height'"></tile-item>
				</div>
				<div class="clearfix"></div>
				<div class="one-third-cell cell clearfix" *ngIf="row.data.length>1">
					<tile-item *ngIf="row.data[1]" [srcUrl]="srcUrl" [dataItem]="row.data[1]" [classList]="'mb hw'" [imageType]="'block1x1'"></tile-item>
					<tile-item *ngIf="row.data[2]" [srcUrl]="srcUrl" [dataItem]="row.data[2]" [classList]="'mb hw ml'" [imageType]="'block1x1'"></tile-item>
					<tile-item *ngIf="row.data[3]" [srcUrl]="srcUrl" [dataItem]="row.data[3]" [classList]="'plate--horizontal'"
					 [imageType]="'block2x1'"></tile-item>
				</div>
				<div class="clearfix"></div>
				<div class="one-third-cell cell clearfix plate--two-height" *ngIf="row.data[4]">
					<tile-item [srcUrl]="srcUrl" [dataItem]="row.data[4]" [imageType]="'block2x2'" [classList]="'plate--two-height'"></tile-item>
				</div>
				<div class="clearfix"></div>
				<div class="one-third-cell cell clearfix" *ngIf="row.data[5]">
					<tile-item [srcUrl]="srcUrl" [dataItem]="row.data[5]" [classList]="'plate--horizontal'" [imageType]="'block2x1'"></tile-item>
				</div>
			</ng-container>

			<ng-container *ngIf="row.type==2">
				<div class="one-third-cell cell clearfix">
					<tile-item [srcUrl]="srcUrl" [dataItem]="row.data[0]" [classList]="'plate--horizontal mb'" [imageType]="'block2x1'"></tile-item>
					<tile-item *ngIf="row.data[1]" [srcUrl]="srcUrl" [dataItem]="row.data[1]" [classList]="'hw'" [imageType]="'block1x1'"></tile-item>
					<tile-item *ngIf="row.data[2]" [srcUrl]="srcUrl" [dataItem]="row.data[2]" [classList]="'hw ml'" [imageType]="'block1x1'"></tile-item>
				</div>
				<div class="clearfix"></div>
				<div class="one-third-cell cell clearfix plate--two-height" *ngIf="row.data[3]">
					<tile-item [srcUrl]="srcUrl" [dataItem]="row.data[3]" [imageType]="'block2x2'" [classList]="'plate--two-height'"></tile-item>
				</div>
				<div class="clearfix"></div>
				<div class="one-third-cell cell clearfix plate--two-height" *ngIf="row.data[4]">
					<tile-item [srcUrl]="srcUrl" [dataItem]="row.data[4]" [imageType]="'block2x2'" [classList]="'plate--two-height'"></tile-item>
				</div>
				<div class="clearfix"></div>

				<div class="one-third-cell cell clearfix" *ngIf="row.data[5]">
					<tile-item [srcUrl]="srcUrl" [dataItem]="row.data[5]" [classList]="'plate--horizontal'" [imageType]="'block2x1'"></tile-item>
				</div>
				<div class="clearfix"></div>

			</ng-container>
		</div>


	</div>
</ng-container>
